import { Container } from 'react-bootstrap';
import React from "react";

const EmptyLayout = ({ children, ...restProps }) => (
    <Container fluid className="empty-wrapper" {...restProps}>
        {/* <Container fluid>{children}</Container> */ children}
    </Container>
);

export default EmptyLayout;
